export default "__VITE_ASSET__D0Au06S3__"